import OKSDK from './oksdk';
import launchState from './launchState';

const postMethods = {
    'appsdata.update': 1,
    'appext.broadcastGetPreviewUrl': 1,
    'appext.broadcastScheduleMessage': 1,
    'photoContest.createCompetition': 1,
    'photoContest.editCompetition': 1,
    'photosV2.commit': 1,
    'photos.commitClones': 1,
    'mediatopic.post': 1
};

function callRemoteApi(params) {
    return new Promise((resolve, reject) => {
        OKSDK.REST.call(
            params.method,
            params,
            (status, data, error) => {
                if (status === 'error') {

                    if (window.LOG_API_CALLS) {
                        console.error(
                            'API call to `' + params.method + '` failed. Params:',
                            params,
                            '. Error:',
                            error
                        );
                    }

                    reject(error);
                } else {
                    if (window.LOG_API_CALLS) {
                        console.info(
                            'API call to `' + params.method + '` succeed. Params:',
                            params,
                            '. Result:',
                            data
                        );
                    }

                    resolve(data);
                }
            },
            {
                use_post: params.method in postMethods,
                access_token: launchState.getAccessToken(),
                no_sig: true
            }
        );
    });
}

const api = {
    call: callRemoteApi
};

if (window.MOCK_DATA) {
    api.mocks = {};
    api.mock = function(success, params, value) {
        const key = JSON.stringify(params);
        this.mocks[key] = { success, ...value };
    };

    api.mockSuccess = api.mock.bind(api, true);
    api.mockFailure = api.mock.bind(api, false);
    api.call = function(params) {
        const key = JSON.stringify(params);
        const mockValue = this.mocks[key];
        if (mockValue) {
            console.log('For call to', params, ', returning mock value', mockValue);
            return new Promise((resolve, reject) => {
                if (mockValue.success) {
                    resolve(mockValue);
                } else {
                    reject(mockValue);
                }
            });
        }

        return callRemoteApi(params);
    };
}

export default api;
